<div class="debug-rect" style="isolation: isolate">
  <div class="wrapper" style="position: absolute; inset: 0; pointer-events: none; user-select: none">
    <div style="position: absolute; inset: 0; background: linear-gradient(to right, black, rgba(255, 0, 0)); mix-blend-mode: screen"></div>
    <div style="position: absolute; inset: 0; background: linear-gradient(to bottom, black, rgba(0, 255, 0)); mix-blend-mode: screen"></div>
    <div
      class="labels"
      style="
        position: absolute;
        inset: 0;
        color: black;
        font-family: monospace;
        font-weight: bold;
        display: grid;
        grid-template-columns: max-content 1fr max-content;
        grid-template-rows: max-content 1fr max-content;
        padding: 4px;
      "
    >
      <p style="grid-area: -1 / 1; background: white; display: inline-block">0,1</p>
      <p style="grid-area: -1 / -1; background: white; display: inline-block">1,1</p>
      <p style="grid-area: 1 / -1; background: white; display: inline-block">1,0</p>
      <p style="grid-area: 1 / 1; background: white; display: inline-block">0,0</p>
    </div>
  </div>
</div>
